<template>
    <div>
        <div class="top">
            <van-nav-bar title="专科优选" left-text="返回" left-arrow @click-left="onClickLeft" />
        </div>
        <van-swipe :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="item in bannerList" :key="item.id" @click="bannerDetail(item)">
                <img :src="item.ad_code" />
            </van-swipe-item>
        </van-swipe>
        <div class="nav">
            <div class="nav-item">
                <div
                    v-for="(item,index) in menuList"
                    :key="index"
                    :class="currentTab===index?'nav-active':''"
                    @click="selectMenu(item,index)"
                >{{item}}</div>
            </div>
        </div>
        <div v-if="currentTab===0">
            <div class="school-one" v-for="(item,index) in schoolList" :key="index">
                <div class="logo-one" @click="schoolDetail(item)">
                    <img :src="item.logo" alt />
                </div>
                <div class="info-one" @click="schoolDetail(item)">
                    <div class="name-one">{{item.name}}</div>
                    <div class="detail">
                        <div>{{item.subjection}}</div>
                        <div>所在城市：{{item.province}}{{item.city}}</div>
                    </div>
                    <div class="detail">
                        <div>录取分：{{item.scoreline}}</div>
                        <div>计划招生：{{item.enrollment}}</div>
                    </div>
                </div>
                <div :class="item.cell ==1?'celled':'favorite'" @click="favorite(item,index)">
                    <van-icon name="star" />
                </div>
            </div>
        </div>
        <!-- 口碑院校 -->
        <van-list
            v-if="currentTab===1"
            style="display: flex;justify-content:space-between;flex-wrap: wrap;padding: 0 8px;"
             finished-text="没有更多了"
            @load="onLoadOne"
             :finished="finished"
        >
            <div
                class="school-two"
                v-for="(item,index) in praiseList"
                :key="index"
                @click="schoolDetail(item)"
            >
                <div class="school-img">
                    <img :src="item.thumb" alt />
                </div>
                <div class="info-two">
                    <div class="logo-two">
                        <img :src="item.logo" alt />
                    </div>
                    <div class="name-two">{{item.name}}</div>
                </div>
            </div>
        </van-list>
        <!-- 中外合作 -->
        <van-list v-if="currentTab===2"  finished-text="没有更多了"
            @load="onLoadTwo"
             :finished="finished">
            <div class="school-one" v-for="(item,index) in zhwaiList" :key="index">
                <div class="logo-one" @click="schoolDetail(item)">
                    <img :src="item.logo" alt />
                </div>
                <div class="info-one" @click="schoolDetail(item)">
                    <div class="name-one">{{item.name}}</div>
                    <div class="detail">
                        <div>{{item.subjection}}</div>
                        <div>所在城市：{{item.province}}{{item.city}}</div>
                    </div>
                    <div class="detail">
                        <div>录取分：{{item.scoreline}}</div>
                        <div>计划招生：{{item.enrollment}}</div>
                    </div>
                </div>
                <div :class="item.cell ==1?'celled':'favorite'" @click="favorite(item,index)">
                    <van-icon name="star"/> 
                </div>
            </div>
        </van-list>
        <van-list v-if="currentTab===3" class="major"  finished-text="没有更多了"
            @load="onLoadThree"
             :finished="finished">
            <div class="major-item" v-for="item in majorList" :key="item.id">
                <div class="major-title">{{item.name}}</div>
                <div class="major-detail">{{item.introduce}}</div>
                <div class="cross-line"></div>
                <div class="major-info">
                    <div class="major-years">
                        <div class="data">{{item.years}}</div>
                        <div>修学年限</div>
                    </div>
                    <div class="line"></div>
                    <div class="major-salary">
                        <div class="data">{{item.wages}}</div>
                        <div>平均薪资</div>
                    </div>
                    <div class="line"></div>
                    <div class="major-top">
                        <div class="data">{{item.hits}}</div>
                        <div>热门排名</div>
                    </div>
                </div>
            </div>
        </van-list>
        <van-list v-if="currentTab===4" class="news" finished-text="没有更多了"
            @load="onLoadFour"
             :finished="finished">
            <div class="news-item" v-for="(item,index) in newsList" :key="index" @click="gobzDetail(item)">
                <div class="news-title">
                    
                    <span>{{item.main}}</span>
                    {{item.subtitle}}
                </div>
                <div class="news-info">
                    <div class="news-image">
                        <img :src="item.thumb" alt />
                    </div>
                    <div class="news-detail">
                        <div class="blod-size">{{item.title}}</div>
                        <div class="news-intro">{{item.description}}</div>
                    </div>
                </div>
                <!-- <div class="news-function">
                    <div>
                        <Icon type="md-share" />转发
                    </div>
                    <div>
                        <Icon type="ios-text-outline" />
                        {{item.comment_num}}
                    </div>
                    <div>
                        <Icon type="ios-thumbs-up-outline" />
                        {{item.zan}}
                    </div>
                </div> -->
            </div>
        </van-list>
    </div>
</template>

<script>
import { httpPost } from "../../../../axios/index";

export default {
    name: "benke",
    data() {
        return {
            currentTab: 0,
            menuList: [
                "全国百强",
                "口碑院校",
                "中外合作",
                "热门专业",
                "专科资讯"
            ],
            bannerList: [], //轮播图
            schoolList: [], //全国百强
            praiseList: [], //口碑院校
            zhwaiList: [], //中外合作
            majorList: [], //专业列表
            newsList: [], //专科资讯
            page: 0,
             type:1,
            finished: false
        };
    },
    methods: {
        // 进入资讯详情
        gobzDetail(e){
            this.$router.push({
                path:"/bzNewsDetail",query:{
                    id:e.id
                }
              }
            )
        },
         // 进入banner详情
        bannerDetail(item) {
            if (item.media_nw === 1) {
                this.$router.push(item.h5_link);
            }
        },
        // 上拉加载
         onLoadOne() {
           
            this.page = this.page + 1;
            if(this.currentTab==1){
                 httpPost("/optimi/more_school", {
                    key:2,
                    type:3,
                    uid: this.$store.state.userInfo.user_id,
                    province: this.$store.state.areaInfo.pid,
                    page: this.page
            }).then(res => {
                if (res.code === 1) {
                   this.praiseList = [...this.praiseList, ...res.data];
                   this.$toast.loading({
                    message: "加载中...",
                    forbidClick: true
                });
                } else {
                    this.finished = true;
                    this.$toast.clear;
                }
                
            });
            }
            },
            onLoadTwo(){
                 this.page = this.page + 1;
                if(this.currentTab==2){
                 httpPost("/optimi/more_school", {
                    key:2,
                    type:2,
                    uid: this.$store.state.userInfo.user_id,
                    province: this.$store.state.areaInfo.pid,
                    page: this.page
            }).then(res => {
                if (res.code === 1) {
                   this.zhwaiList = [...this.zhwaiList, ...res.data];
                } else {
                    this.finished = true;
                }
                this.$toast.loading({
                    message: "加载中...",
                    forbidClick: true
                });
            });
            }
            },
            onLoadThree(){
                 this.page = this.page + 1;
                 httpPost("/optimi/more_major", {
                    key:2,
                    type:4,
                    uid: this.$store.state.userInfo.user_id,
                    province: this.$store.state.areaInfo.pid,
                    page: this.page
            }).then(res => {
                if (res.code === 1) {
                   this.majorList = [...this.majorList, ...res.data];
                } else {
                    this.finished = true;
                }
                this.$toast.loading({
                    message: "加载中...",
                    forbidClick: true
                });
            });
           
            },
            onLoadFour(){
                this.page = this.page + 1;
                 httpPost("/optimi/news", {
                    key:2,
                    type:5,
                    uid: this.$store.state.userInfo.user_id,
                    province: this.$store.state.areaInfo.pid,
                    page: this.page
            }).then(res => {
                if (res.code === 1) {
                   this.newsList = [...this.newsList, ...res.data];
                } else {
                    this.finished = true;
                }
                this.$toast.loading({
                    message: "加载中...",
                    forbidClick: true
                });
            });
          
            },
        // 点击收藏
        favorite(e,index) {
          
              var schoolList = this.schoolList;
              var zhwaiList = this.zhwaiList;
              if (this.$store.state.userInfo.user_id!= null){
            httpPost("/usercell/school_cell", {
                uid: this.$store.state.userInfo.user_id,
                school_id: e.id
            }).then(res => {
               
                   for (var i = 0; i < schoolList.length; i++) {
                            if (index == i) {
                                if (schoolList[i].cell == 1) {
                                  this.$toast.fail("取消收藏成功")
                                    schoolList[i].cell = 0;
                                } else {
                                    this.$toast.success("收藏成功")
                                    schoolList[i].cell = 1;
                                }
                            }
                   }
                   for (var i = 0; i < zhwaiList.length; i++) {
                            if (index == i) {
                                if (zhwaiList[i].cell == 1) {
                                  this.$toast.fail("取消收藏成功")
                                    zhwaiList[i].cell = 0;
                                } else {
                                    this.$toast.success("收藏成功")
                                    zhwaiList[i].cell = 1;
                                }
                            }
                   }
            });
              }else{
                  this.$toast("请先去登录")
                  this.$router.push("/login");
              }
        },
        onClickLeft() {
            this.$router.go(-1);
        },
        goDetail(item) {
            this.$store.state.schoolId = item.id;
            this.$router.push("/schoolDetail");
          
        },
        schoolDetail(i) {
           var select=i.praise;
                this.$store.state.schoolId = i.id;
                if(select==0){
                    this.$router.push({path:"/schoolDetail",query:{id:i.id}});
                }
                 if (select == 1){
                         this.$router.push({path:"/schoolSelectDetail",query:{id:i.id}});
                 }
                  if (select == 2){
                         this.$router.push({path:"/schoolSelectDetail",query:{id:i.id}});
                 }
        },
        selectMenu(item, index) {
            this.currentTab = index;
        },
        loadSchool() {
            // 获取专科优选的轮播
              httpPost("/ad/rotation_specialty", {
                 province: this.$store.state.areaInfo.pid,
                 uid: this.$store.state.userInfo.user_id,
            }).then(res => {
                if (res.code === 1) {
                     this.bannerList=res.banlist
                }
            });
            httpPost("/optimi/index", {
                 province: this.$store.state.areaInfo.pid,
                 uid: this.$store.state.userInfo.user_id,
                key: 2
            }).then(res => {
                if (res.code === 1) {
                    this.schoolList = res.school;
                    this.praiseList = res.praise;
                    this.zhwaiList = res.zhwai;
                    this.majorList = res.major;
                    this.newsList = res.news;
                }
            });
        }
    },
    mounted() {
        this.loadSchool();
    }
};
</script>

<style scoped>
.van-list>>>.van-list__finished-text{
    width: 100% !important;
}
.nav {
    position: relative;
    font-size: 0.8rem;
    color: #808080;
    width: 95vw;
    margin: 1rem 2.5vw 0.5rem;
    height: 2.7rem;
    border-radius: 10px;
    padding-top: 10px;
    box-shadow: 0 0 0.04rem 0.04rem #f4f4f4;
}

.nav-item {
    display: flex;
    justify-content: space-around;
    position: absolute;
    text-align: center;
    width: 90vw;
}

.nav-active {
    color: rgb(120, 120, 120);
    border-bottom: 0.2rem solid #24d5ab;
}
.news-image img{
    border-radius: 10px;
}
img {
    width: 100%;
    height: 100%;
    
}
.school-one {
    width: 95vw;
    margin: 0 auto 1rem;
    box-shadow: 0 0 0.8rem rgba(0, 0, 0, 0.2);
    border-radius: 0.5rem;
    background: rgb(255, 255, 255);
    display: flex;
    position: relative;
}
.school-one img {
    border-radius: 0.5rem;
}
.logo-one {
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    overflow: hidden;
    margin: 0.8rem;
}
.name-one {
    font-size: 0.9rem;
    font-weight: 600;
    padding-top: 1rem;
}
.detail {
    display: flex;
}
.detail div:nth-child(1) {
    width: 5rem;
}
.detail div:nth-child(2) {
    padding-left: 0.5rem;
}
.favorite {
    position: absolute;
    right: 1rem;
    top: 1rem;
    font-size: 1.2rem;
    z-index: 100;
}
.celled{
     position: absolute;
     right: 1rem;
     top: 1rem;
     font-size: 1.2rem;
     z-index: 100;
      color: #e5b626; 
}
.school-two {
    width: 30vw;
    margin-bottom: 1rem;
    border-radius: 0.2rem;

    background: #fff;
}
.school-img {
    width: 100%;
    height: 9rem;

    box-shadow: 0 0 0.8rem rgba(0, 0, 0, 0.2);
}
.school-img img {
    border-radius: 0.2rem;
}
.logo-two {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    margin: 0.3rem;
}
.info-two {
    display: flex;
}
.name-two {
    height: 1.2rem;
    overflow: hidden;
    font-size: 0.7rem;
    line-height: 1.7rem;
}
/* 专业*/
.major {
    width: 95vw;
    margin: 1rem 2.5vw;
}

.major-item {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    border-radius: 0.2rem;
    background: #fff;
    margin-bottom: 1rem;
}
.major-title {
    text-align: center;
    padding: 0.5rem 0 0.4rem 0;
}

.major-detail {
    color: #5b5b5b;
    line-height: 1.5;
    padding: 0 0.2rem 1rem;
}

.major-info {
    display: flex;
}

.major-years,
.major-salary,
.major-top {
    width: 30vw;
    margin: 0.8rem 0;
    text-align: center;
}

.data {
    padding-bottom: 0.8rem;
}

.cross-line {
    width: 100%;
    margin: 0 auto;
    height: 0.05rem;
    background: #e2eaed;
}

.line {
    width: 0.05rem;
    height: 2rem;
    background: #e2eaed;
    margin-top: 1rem;
}
/*咨询*/
.news {
    background: #e6e6e6;
}
.news-item {
    margin-bottom: 1rem;
    padding: 3px 0.5rem;
    background: #fff;
}
.news-title {
    font-size: 1rem;
    font-weight: 600;
    color: #383838;
}
.news-title span {
    color: #06b2b6;
}
.news-info {
    display: flex;
    padding: 0.3rem 0;
    background: #f5f5f5;
}
.news-image {
    width: 9rem;
    height: 6rem;
    background: #888888;
    margin-right: 10px;
}
.blod-size {
    font-size: 1rem;
    font-weight: 600;
    color: #383838;
}
.news-detail {
    width: 80%;
}
.news-intro {
    width: 100%;
    height: 3rem;
    overflow: hidden;
}
.news-function {
    display: flex;
    justify-content: space-around;
    line-height: 2.5rem;
    font-size: 0.9rem;
}
</style>